module.exports = __webpack_public_path__ + "static/media/BANNER-REFACCIONES.db5a80f7.png";